export default "__VITE_ASSET__CUUro4qY__"